import { type FieldContentsData } from 'javascripts/shared-types';
import CustomField from '../CustomField';

export default class LinkCustomField extends CustomField {
  exampleContents() {
    return {
      tags: [{ name: this.customFieldDefinition.name, color: '#666666' }],
    };
  }

  contentsForRecord(record: any): FieldContentsData {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (
      Array.isArray(customFieldValue?.value) &&
      customFieldValue.value.length
    ) {
      return {
        tags: customFieldValue.value.map((name: string) => ({
          name,
          color: '#666666',
        })),
      };
    }

    return {};
  }
}
